/**
 * billing.bands_off: the rate bands switched off (Admin, Rate bands). The
 * browser twin of api/_shared/bandsOff.ts; keep the two in lockstep (the
 * shared unit fixtures in tests/ui/bandsOff.test.ts read
 * both).
 *
 * Off is a filter on what is OFFERED, never on the vocabulary: the
 * pickers and the server's band gate subtract an off band, while every
 * reader that labels, prices, pays or exports an existing row keeps
 * reading readRateBands and still sees it.
 *
 * The value is a JSON array of band values. Non-strings, blanks and
 * duplicates are dropped, and values are trimmed; anything unset or not
 * an array reads as every band on.
 */

/** The bands switched off, from a tenants.config value. Pure. */
export function readBandsOff(config: unknown): ReadonlySet<string> {
  if (typeof config !== 'object' || config === null) return new Set();
  const billing = (config as Record<string, unknown>).billing;
  if (typeof billing !== 'object' || billing === null) return new Set();
  const v = (billing as Record<string, unknown>).bands_off;
  if (!Array.isArray(v)) return new Set();
  const out = new Set<string>();
  for (const entry of v) {
    if (typeof entry !== 'string') continue;
    const band = entry.trim();
    if (band !== '') out.add(band);
  }
  return out;
}

/** A band list without the bands switched off, in its own order. Pure. */
export function withoutOffBands<T extends { value: string }>(bands: readonly T[], config: unknown): T[] {
  const off = readBandsOff(config);
  return bands.filter((b) => !off.has(b.value));
}
